import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../entities/error.entity";
import QAResponseQuestionEntity from "../entities/qa_response_question.entity";
import QAResultEntity from "../entities/qa_result.entity";
import SearchResultEntity from "../entities/search_result.entity";
import QAResumeEntity from "../entities/qa_resume.entity";
import HumanAgentEntity from "../entities/human_agent.entity";

export default interface QAResumeRepository {
    updateResponseQuestion(response: QAResponseQuestionEntity, jobId: string): Promise<Either<ErrorEntity, QAResponseQuestionEntity>>;
    uploadAudioForTranscription(_: { audio: File, humanAgentId: string, iaAgentId: string, onCallBack?: (progress: number, message: string) => void }): Promise<Either<ErrorEntity, string>>;
    getAudioResults(_: { jobId: string, onCallBack?: (progress: number, message: string) => void, humanAgent?: HumanAgentEntity }): Promise<Either<ErrorEntity, QAResultEntity>>;
    search(_: {
        query?: string;
        humanAgentId?: string;
        page: number;
        itemsPerPage: number;
        from?: Date;
        to?: Date;
        call_state?: string;
        sentiment?: string;
        audio_name?: string;
        human_agent_name?: string;
      }): Promise<Either<ErrorEntity, SearchResultEntity<QAResumeEntity>>>;
          downloadAll(_: { humanAgentId?: string; from?: Date, to?: Date }): Promise<Either<ErrorEntity, void>>;
}

export const QAResumeRepositoryName = "QAResumeRepository";